import { render, staticRenderFns } from "./StatusUser.vue?vue&type=template&id=30d772d8&"
import script from "./StatusUser.vue?vue&type=script&lang=js&"
export * from "./StatusUser.vue?vue&type=script&lang=js&"
import style0 from "./StatusUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports